import React from "react";
import { get } from "lodash";

export const PolicyPartnerLoginFrame = ({ user }) => (
  <>
    {get(user, "policyPartnerUrl") && (
      <img
        src={get(user, "policyPartnerUrl")}
        style={{ display: "none" }}
        title="Policy Partner"
      />
    )}
  </>
);

export default PolicyPartnerLoginFrame;
